import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type SsoAuthUrlResponseType = {
  url: string;
};

export const useGetSsoAuthUrl = (
  options: QueryOptions<SsoAuthUrlResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<SsoAuthUrlResponseType> => {
      const { data } = await api.get<ApiResponse<SsoAuthUrlResponseType>>(
        `/auth/azure/login-url`
      );
      return data.data;
    },
    queryKey: ['sso-url'],
    enabled: false,
    ...options,
  });
